import * as React from 'react';
import { PromoItem } from './components/PromoItem';
import * as styles from './PromoPreview.css';
import { IPromo } from '../../types/newbuilding/promos';
import { getPromoIcon } from '../../utils/promos';

interface IPromoPreviewProps {
  onPromoClick?(promo: IPromo): void;
  onPromoHover?(promo: IPromo): void;
  promos: IPromo[];
}

export function PromoPreview({ promos, onPromoClick, onPromoHover }: IPromoPreviewProps) {
  const reversedPromos = React.useMemo(() => promos.reverse(), [promos]);

  return (
    <div className={styles['container']}>
      {reversedPromos.map(promo => {
        const promoIcon = getPromoIcon(promo);

        if (promoIcon == null) {
          return null;
        }

        return (
          <PromoItem
            key={promo.uniquePromoId}
            promo={promo}
            onHover={onPromoHover}
            onClick={onPromoClick}
            icon={promoIcon}
          />
        );
      })}
    </div>
  );
}
